// extracted by mini-css-extract-plugin
export var cartIcon = "_nb-0";
export var cartIconContainer = "_nb-1";